export interface IExternalSSPAPI {
  code: string;
  currency: string;
  logo_url: string;
  name: string;
  ssp_id: number;
}

export default class ExternalSSP {
  constructor(
    public code: string,
    public currency: string,
    public logoUrl: string,
    public name: string,
    public id: number,
  ) {}

  static fromApi(apiObject: IExternalSSPAPI): ExternalSSP {
    return new ExternalSSP(apiObject.code, apiObject.currency, apiObject.logo_url, apiObject.name, apiObject.ssp_id);
  }
}
